import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/homeMocks';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-heading font-bold text-primary-500">aigei</span>
            <span className={`hidden md:inline text-sm transition-colors ${isScrolled || !isHome ? 'text-foreground-600' : 'text-white/80'}`}>专业游戏素材平台</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'text-primary-500 bg-primary-50 font-medium'
                      : isScrolled || !isHome
                        ? 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                        : 'text-white/85 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm px-4 py-2 rounded-lg border transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? 'border-primary-300 text-primary-600 hover:bg-primary-50'
                  : 'border-white/40 text-white hover:bg-white/10'
              }`}
            >
              登录
            </Link>
            <Link
              to="/about"
              className="text-sm px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              免费注册
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              isScrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href || (link.href !== '/' && location.pathname.startsWith(link.href));
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-3 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap ${
                    isActive
                      ? 'text-primary-500 bg-primary-50 font-medium'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="flex gap-2 mt-2 pt-2 border-t border-background-200/70">
              <Link to="/about" className="flex-1 text-center text-sm py-2 rounded-lg border border-primary-300 text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap">
                登录
              </Link>
              <Link to="/about" className="flex-1 text-center text-sm py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap">
                免费注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}